"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppRouter = void 0;
/* Package Imports */
var connected_react_router_1 = require("connected-react-router");
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
/* Blast Imports */
var ProtectedRoute_1 = __importDefault(require("./components/routing/ProtectedRoute"));
var ForgotPasswordPage_1 = __importDefault(require("./features/auth/pages/ForgotPasswordPage"));
var LoginWrapper_1 = __importDefault(require("./features/auth/pages/LoginWrapper"));
var PasswordExpired_1 = require("./features/auth/pages/PasswordExpired");
var ResetPasswordPage_1 = __importDefault(require("./features/auth/pages/ResetPasswordPage"));
var Dashboard_1 = __importDefault(require("./features/dashboard/Dashboard"));
var ErrorPage_1 = require("./features/error/pages/ErrorPage");
var DeliveryPage_1 = require("./features/packages/pages/DeliveryPage");
var RegisterPage_1 = __importDefault(require("./features/registration/pages/RegisterPage"));
var RegistrationConfirmationPage_1 = __importDefault(require("./features/registration/pages/RegistrationConfirmationPage"));
var rootReducer_1 = require("@app/_state/rootReducer");
var AppRouter = function () { return (react_1.default.createElement(connected_react_router_1.ConnectedRouter, { history: rootReducer_1.history },
    react_1.default.createElement(react_router_dom_1.Switch, null,
        react_1.default.createElement(react_router_dom_1.Route, { path: "/error/:type?", component: ErrorPage_1.ErrorPage }),
        react_1.default.createElement(react_router_dom_1.Route, { path: "/login", component: LoginWrapper_1.default }),
        react_1.default.createElement(react_router_dom_1.Route, { path: "/forgot-password", component: ForgotPasswordPage_1.default }),
        react_1.default.createElement(react_router_dom_1.Route, { path: "/password-expired", component: PasswordExpired_1.PasswordExpired }),
        react_1.default.createElement(react_router_dom_1.Route, { path: "/reset-password", component: ResetPasswordPage_1.default }),
        react_1.default.createElement(react_router_dom_1.Route, { path: "/register/confirmation", component: RegistrationConfirmationPage_1.default }),
        react_1.default.createElement(react_router_dom_1.Route, { path: "/register/:email?", component: RegisterPage_1.default }),
        react_1.default.createElement(react_router_dom_1.Route, { path: "/packages/delivery", component: DeliveryPage_1.DeliveryPage }),
        react_1.default.createElement(ProtectedRoute_1.default, { path: "/dash", component: Dashboard_1.default }),
        react_1.default.createElement(react_router_dom_1.Redirect, { from: "/", to: "/dash" })))); };
exports.AppRouter = AppRouter;
